// Dropzone auto-attaches to every .dropzone element on DOMContentLoaded, which collides with the
// manual .dropzone() init each upload form does — the second attach throws "Dropzone already
// attached" and aborts the rest of that ready handler. The class stays on the markup: Dropzone
// needs it to render the .dz-message drop hint.
if (window.Dropzone) {
    Dropzone.autoDiscover = false;
}

function CountDownTimer(dt, id, days1, days2, day) {
    var end = new Date(dt);

    var _second = 1000;
    var _minute = _second * 60;
    var _hour = _minute * 60;
    var _day = _hour * 24;
    var timer, daysText;

    function showRemaining() {
        var now = new Date();
        var distance = end - now;
        if (distance < 0) {
            clearInterval(timer);
            document.getElementById(id).innerHTML = "EXPIRED!";

            return;
        }
        var days = Math.floor(distance / _day) + 1;

        if (days >= 5) {
            daysText = days1;
        } else if (days < 5 && days !== 1) {
            daysText = days2;
        } else if (days === 1) {
            daysText = day;
        }

        document.getElementById(id).innerHTML = days + " " + daysText;
    }

    timer = setInterval(showRemaining, 1000);
}

/** POST a signal/URL and save the PDF it answers; throws Error(message) (empty = caller's generic text) */
async function postDownload(url, data, fallbackName) {
    const response = await fetch(url, {
        method: "POST",
        body: new URLSearchParams($.param(data || {})),
        headers: { "X-Requested-With": "XMLHttpRequest" },
        credentials: "same-origin",
    });

    // an expired session answers 200 with a redirect payload or the login page, which must not be saved as a .pdf
    if (!response.ok || !(response.headers.get("Content-Type") || "").startsWith("application/pdf")) {
        let message = "";
        try {
            message = (await response.json()).message;
        } catch (e) {
            // not JSON: the caller shows its generic text
        }
        throw new Error(message || "");
    }

    const objectUrl = window.URL.createObjectURL(await response.blob());
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = objectUrl;
    a.download = response.headers.get("Filename") || fallbackName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(objectUrl);
}

/** Definice Flash message */
function flashMessage(message, type) {
    let typ = type;
    if (type === "g") {
        typ = "success";
    } else if (type === "w") {
        typ = "warning";
    } else if (type === "r") {
        typ = "error";
    }

    toastr.options = {
        closeButton: false,
        debug: false,
        newestOnTop: true,
        progressBar: true,
        positionClass: "toast-top-center",
        preventDuplicates: true,
        onclick: null,
        showDuration: "300",
        hideDuration: "1000",
        timeOut: "5000",
        extendedTimeOut: "1000",
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "fadeOut",
    };
    toastr[typ](message);
}

function toggleFormControls(checkBoxSelector, divSelector, inverse) {
    $(document).on("change", checkBoxSelector, function () {
        $(divSelector).slideToggle(500);
    });
    const checked = $(checkBoxSelector).prop("checked");
    if ((!inverse && !checked && $(checkBoxSelector).length) || (inverse && checked)) $(divSelector).hide();
}

/**
 * Snippet Modals + spinner
 */
NProgress.configure({
    showSpinner: false,
});

const realColumn = (table, i) => {
    if (table.colReorder) {
        const idx = table.colReorder.transpose(i);

        return {
            index: idx,
            column: table.column(idx),
        };
    }

    return {
        index: i,
        column: table.column(i),
    };
};

// DataTables 1.13 matches diacritics literally; folding its search data instead would break the
// exact-match ^value$ filters and SearchPanes, so each typed letter becomes a class of its variants.
const ACCENT_VARIANTS = (() => {
    const map = {};
    for (const ch of "áàâäãåąčçćďéèêëěęíìîïĺľňñńóòôöõőŕřšśťúùûüůűýÿžźż") {
        const base = ch.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        map[base] = (map[base] || base) + ch;
    }
    return map;
})();

function accentInsensitiveSearch(text) {
    return $.fn.dataTable.util
        .escapeRegex(text)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[a-z]/gi, (ch) => {
            const variants = ACCENT_VARIANTS[ch.toLowerCase()];
            return variants ? `[${ch}${variants.slice(1)}]` : ch;
        });
}

function accentSearchToText(search) {
    // One left-to-right pass instead of a (?<!\\) lookbehind: iOS < 16.4 cannot parse lookbehind, and
    // the SyntaxError kills the whole bundle.js (jQuery included), leaving the login preloader up for good.
    return search.replace(/\\(.)|\[([a-z])[^\]]*\]/gi, (match, escaped, letter) => escaped || letter);
}

function dtDefaultInitComplete() {
    let table = this.api();
    let savedState = table.state();

    table.columns().every(function (i) {
        let column = this;
        let index = i;
        if (table.colReorder) {
            index = table.colReorder.transpose(i);
            column = table.column(index);
        }

        let footer = $(column.footer());
        if (footer.hasClass("search")) {
            let value = savedState ? accentSearchToText(savedState.columns[index].search.search) : "";

            let inpt = $(
                `<input class="dt-inf-search" type="text" placeholder="" value="${value}" data-column="${i}">`
            );
            // Each draw filters every row, so typing redraws once after a pause, not per key.
            let timer = null;
            $(inpt).on("input clear", function () {
                const input = this;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    const col = realColumn(table, $(input).data("column"));
                    const search = accentInsensitiveSearch($.fn.DataTable.ext.type.search.string(input.value));
                    if (col.column.search() !== search) {
                        col.column.search(search, true, true).draw();
                    }
                }, 250);
            });

            footer.html(inpt);
        } else if (footer.hasClass("filter-select")) {
            let value = savedState ? savedState.columns[index].search.search : "";

            const isMultiple = footer.data("multiple");
            const isSelectpicker = footer.data("selectpicker");

            let inpt = $(`<select class="${isSelectpicker ? "render-selectpicker" : "dt-inf-filter-select"}" ${
                isMultiple ? "multiple" : ""
            } data-column="${i}">
                ${isMultiple ? "" : '<option value=""></option>'}
            </select>`);

            $(inpt).on("change", function (e) {
                if ($(e).hasClass("placeholder")) {
                    $(this).addClass("placeholder");
                } else {
                    $(this).removeClass("placeholder");
                }

                const colIndex = $(this).data("column");

                const col = realColumn(table, colIndex);

                if (footer.hasClass("use-regex")) {
                    var val = $.fn.dataTable.util.escapeRegex($(this).val());
                    col.column.search(val ? "^" + val + "$" : "", true, false).draw();
                } else {
                    const val = $(this).val();

                    if (isMultiple) {
                        if (val && val.length > 0) {
                            const escaped = val.map((str) => $.fn.dataTable.util.escapeRegex(str));
                            const searchTerm = "^(" + escaped.join("|") + ")$";

                            col.column.search(searchTerm, true, false).draw();
                        } else {
                            col.column.search("").draw();
                        }
                    } else {
                        col.column.search($.fn.DataTable.ext.type.search.string(val)).draw();
                    }
                }
            });

            let optionSet = [];
            let optionsCount = 0;

            if (footer.data("custom-options")) {
                const options = footer.data("custom-options");

                Object.entries(options).forEach((entry) => {
                    const [k, v] = entry;

                    let option = $("<option>").val(k).text(v);
                    let cleanedSearch = $.fn.DataTable.ext.type.search.string(k);
                    let cleanedRegex = "\\b" + k + "\\b";
                    // use-regex single selects save "^k$" (escaped), which the \b-format checks never matched.
                    let anchoredRegex = "^" + $.fn.dataTable.util.escapeRegex(k) + "$";
                    if (
                        cleanedSearch == value ||
                        cleanedRegex == value ||
                        anchoredRegex == value ||
                        (isMultiple && value.includes(cleanedRegex))
                    ) {
                        option.prop("selected", true).attr("selected", "selected");
                    }
                    inpt.append(option);
                    optionsCount += 1;
                });
            } else {
                column
                    .data()
                    .unique()
                    .sort()
                    .each(function (d, j) {
                        if (d && d.length > 0) {
                            let cleaner = document.createElement("div");
                            cleaner.innerHTML = d;
                            let cleaned = cleaner.textContent || cleaner.innerText || "";
                            let customSearch = $(cleaner).find("span.data-search");
                            if (customSearch) {
                                if (customSearch.text().length > 0) {
                                    cleaned = customSearch.text();
                                    if (!optionSet.includes(cleaned)) {
                                        optionSet.push(cleaned);
                                    } else {
                                        return true;
                                    }
                                }
                            }

                            let option = $("<option>").val(cleaned).text(cleaned);
                            let cleanedSearch = $.fn.DataTable.ext.type.search.string(cleaned);
                            let cleanedRegex = "^" + cleaned + "$";
                            if (cleanedSearch == value || cleanedRegex == value) {
                                option.prop("selected", true).attr("selected", "selected");
                            }
                            inpt.append(option);
                            optionsCount += 1;
                        }
                    });
            }

            if (optionsCount === 0) {
                inpt.prop("disabled", true);
            }

            footer.html(inpt);
        }
    });

    const header = this.api().table().header();
    $("tr", this.api().table().footer()).appendTo(header);

    // „Resetovat filtr" in the footer band while a column filter is set, as in the Ublaboo grids.
    const footerInfo = $(table.table().container()).children(".fi-dt-footer").children(".dataTables_info");
    if (footerInfo.length) {
        const reset = $('<a href="#" class="btn btn-sm btn-link reset-filter"><i class="fas fa-times"></i> </a>')
            .append(document.createTextNode(table.i18n("fiResetFilter", "Resetovat filtr")))
            .on("click", function (e) {
                e.preventDefault();
                table.columns().search("");
                $(header).find(".dt-inf-search, .dt-inf-filter-select").val("");
                $(header).find("select.render-selectpicker").val([]).selectpicker("refresh");
                table.draw();
            });
        const toggle = () => reset.toggle(table.columns().search().toArray().some(Boolean));
        footerInfo.after(reset);
        table.on("draw.dt", toggle);
        toggle();
    }

    if ($(header).find("select.render-selectpicker").length > 0) {
        $(header).find("select.render-selectpicker").selectpicker({
            container: "body",
            noneSelectedText: "Nevybráno..",
            liveSearch: true,
            liveSearchNormalize: true,
            size: 5,
            width: "100%",
        });
    }
}

$(function () {
    "use strict";

    $(".preloader").fadeOut(200, () => {
        $("#main-wrapper").removeClass("preloader-no-anim");
    });

    $("select").on("select2:select", function (e) {
        $(".select2-search__field").val("").focus();
    });

    $("#main-wrapper").AdminSettings({
        Theme: false,
        Layout: "vertical",
        LogoBg: "skin6",
        NavbarBg: "skin1",
        SidebarType: "full",
        SidebarColor: "skin6",
        SidebarPosition: true,
        HeaderPosition: true,
        BoxedLayout: false,
    });

    $.nette.ext("nprogress", {
        start: function () {
            window.NProgress.start();
        },
        complete: function () {
            window.NProgress.done();
        },
    });

    $.nette.ext(
        "modals",
        {
            before: function () {
                this.wasModalOpenedBeforeAjaxRequest = this.isModalOpened();
                this.lastOpenedModalId = this.lastOpenedModal();

                if (this.wasModalOpenedBeforeAjaxRequest) {
                    $(".modal-ajax .modal-loader").show();
                    // Islands (Vue) inside the modal own their buttons' disabled state — touching
                    // them here re-enabled the order editor's „Uložit" on an empty list.
                    $(".modal-ajax a.btn, .modal-ajax button").not("[data-island] *").attr("disabled", true).addClass("disabled");
                }
            },
            success: function (payload) {
                $(".modal-ajax .modal-loader").hide();
                $(".modal-ajax a.btn, .modal-ajax button").not("[data-island] *").attr("disabled", false).removeClass("disabled");

                // Every response starts clean — the old code appended, so each failed submit
                // stacked one more copy of the same banner.
                $(".modal-errors").empty();
                $(".modal-ajax .js-server-error").remove();
                $(".modal-ajax .js-server-invalid").removeClass("is-invalid js-server-invalid");

                var banner = function (text) {
                    // chybové hlášky nesou uživatelský vstup (např. jméno klienta) – jen jako text
                    $(".modal-errors").append(
                        $("<p/>").addClass("modal-error alert alert-danger").attr("role", "alert").text(text)
                    );
                };

                // Control errors (BasePresenter::modalFormValidationFailed) go under their field:
                // the control gets .is-invalid (select2 and flatpickr skins key off it), its
                // .input-wrapper carries the message. A field the DOM does not have falls back
                // to the banner.
                var firstInvalid = null;
                (payload.modalFieldErrors || []).forEach((e) => {
                    var el = document.getElementById(e.id) || document.querySelector('.modal-ajax [name="' + e.name + '"]');
                    if (!el) {
                        banner(e.message);
                        return;
                    }
                    var $el = $(el);
                    var $wrap = $el.closest(".input-wrapper");
                    $el.addClass("is-invalid js-server-invalid");
                    if ($wrap.length) {
                        $wrap.addClass("is-invalid js-server-invalid");
                    }
                    ($wrap.length ? $wrap : $el.parent()).append(
                        $("<div/>").addClass("invalid-feedback d-block js-server-error").text(e.message)
                    );
                    firstInvalid = firstInvalid || ($wrap.length ? $wrap[0] : el);
                });
                (payload.modalFormErrors || []).forEach(banner);
                // An inline error stays until the user touches the field, then it is theirs again.
                $(".modal-ajax").off("change.fiServerError").on("change.fiServerError", ".js-server-invalid", function () {
                    var $wrap = $(this).closest(".input-wrapper");
                    $(this).removeClass("is-invalid js-server-invalid");
                    $wrap.removeClass("is-invalid js-server-invalid").find(".js-server-error").remove();
                });
                if (firstInvalid && typeof firstInvalid.scrollIntoView === "function") {
                    firstInvalid.scrollIntoView({ block: "center", behavior: "smooth" });
                } else if (payload.modalFormErrors && payload.modalFormErrors.length) {
                    $(".modal-ajax .modal-body").scrollTop(0);
                }

                if (payload.keepModal) return;

                if (payload.isModal) {
                    if (!this.wasModalOpenedBeforeAjaxRequest) {
                        $(".modal-ajax").modal("show");
                    } else {
                        if (this.lastOpenedModalId === payload.modalId) {
                            $(".modal-ajax").removeClass("fade");
                        }
                        $(".modal-ajax").addClass("in").css({ display: "block" }).modal("show");
                        $(".modal-backdrop").removeClass("fade");
                        $(".modal-backdrop:not(:last)").remove();
                        window.setTimeout(function () {
                            $(".modal-ajax").addClass("fade");
                            $(".modal-backdrop").addClass("fade");
                        }, 200);
                    }
                } else {
                    $(".modal-backdrop").remove();
                    $("body").removeClass("modal-open");
                    $(".modal-ajax").modal("hide");
                }
            },
            // Without this a failed request (500, timeout) left the loader over the modal for good.
            error: function (jqXHR, status) {
                if (!this.wasModalOpenedBeforeAjaxRequest || status === "abort") return;

                $(".modal-ajax .modal-loader").hide();
                $(".modal-ajax a.btn, .modal-ajax button").not("[data-island] *").attr("disabled", false).removeClass("disabled");
                $(".modal-errors")
                    .empty()
                    .append(
                        $("<p/>")
                            .addClass("modal-error alert alert-danger")
                            .attr("role", "alert")
                            .text("Požadavek se nepodařilo dokončit. Zkuste to prosím znovu, případně kontaktujte podporu.")
                    );
                $(".modal-ajax .modal-body").scrollTop(0);
            },
        },
        {
            wasModalOpenedBeforeAjaxRequest: false,
            isModalOpened: function () {
                return $("body").hasClass("modal-open");
            },
            lastOpenedModal: function () {
                return $(".modal-ajax.show").attr("id");
            },
        }
    );

    $(document).on("change", ".dataTables_length select", function (e) {
        let id = $(this).attr("name");
        let storageName = "default_" + id;
        localStorage.setItem(storageName, $(this).val());
    });

    $(document).on("show.bs.modal hide.bs.modal", ".modal", function () {
        $("body").css("padding-right", "0");
    });

    $(".left-sidebar")
        .on("mouseenter", function () {
            $(".navbar-header").addClass("expand-logo");
        })
        .on("mouseleave", function () {
            $(".navbar-header").removeClass("expand-logo");
        });

    // this is for close icon when navigation open in mobile view
    $(".nav-toggler").on("click", function () {
        $("#main-wrapper").toggleClass("show-sidebar");
        $(".nav-toggler i").toggleClass("fa-bars");
        if ($(".nav-toggler i").hasClass("fa-bars")) {
            $(".nav-toggler i").removeClass("fa-times");
        } else {
            $(".nav-toggler i").addClass("fa-times");
        }
    });

    $(".datepicker")
        .datepicker({
            autoclose: true,
            clearBtn: true,
            daysOfWeekHighlighted: [0, 6],
            enableOnReadonly: false,
            language: "cs",
            format: "dd.mm.yyyy",
            todayHighlight: true,
        })
        .on("changeDate", function (e) {
            let inptId = $(this).data("update-id");
            let inpt = $("#" + inptId);

            let newDate = moment(e.date, "dd.mm.YYYY").format("YYYY-MM-DD");
            inpt.val(newDate).trigger("change");
        });

    $(".datepicker").each(function () {
        let inptId = $(this).data("update-id");
        let inpt = $("#" + inptId);

        let d = inpt.val();
        if (d) {
            let newDate = moment(e.date, "YYYY-MM-DD").format("dd.mm.YYYY");
            $(this).val(newDate);
        }
    });

    $.widget.bridge("uitooltip", $.ui.tooltip);
    $('[data-toggle="tooltip"]').tooltip({ trigger: "hover", boundary: "window" });
    $('[data-toggle="popover"]').popover();

    $(".message-center, .customizer-body, .scrollable").each(function () {
        let el = $(this)[0];
        const ps = new PerfectScrollbar(el);
    });

    $(".mailbox").on("wheel", function (e) {
        e.preventDefault();
        e.stopPropagation();
    });

    $(".mailbox .prevent-close, .mailbox .ps__rail-y, .mailbox .ps__thumb-y").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
    });

    $("body, .page-wrapper").trigger("resize");

    $(".list-task li label").on("click", function () {
        $(this).toggleClass("task-done");
    });

    $('a[data-action="collapse"]').on("click", function (e) {
        e.preventDefault();
        $(this).closest(".card").find('[data-action="collapse"] i').toggleClass("ti-minus ti-plus");
        $(this).closest(".card").children(".card-body").collapse("toggle");
    });
    $('a[data-action="expand"]').on("click", function (e) {
        e.preventDefault();
        $(this).closest(".card").find('[data-action="expand"] i').toggleClass("mdi-arrow-expand mdi-arrow-compress");
        $(this).closest(".card").toggleClass("card-fullscreen");
    });
    $('a[data-action="close"]').on("click", function () {
        $(this).closest(".card").removeClass().slideUp("fast");
    });

    $(document).on("click", ".mega-dropdown", function (e) {
        e.stopPropagation();
    });

    $(".rodne-cislo").on("change", function () {
        let rc = $(this).val();
        let len = rc.length;
        if (len >= 9) {
            let part = rc.substr(0, 6);
            let day = parseInt(part.substr(4, 2));
            let month = parseInt(part.substr(2, 2));
            if (month > 12) {
                month -= 50;
            }
            let year = parseInt(part.substr(0, 2));
            if (year < 54 && len > 9) {
                year += 2000;
            } else {
                year += 1900;
            }
            let parsed = year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
            console.log(parsed);
            $(".datum-narozeni").val(parsed);
        }
    });

    $(".show-left-part").on("click", function () {
        $(".left-part").toggleClass("show-panel");
    });
});
